import baseContainer from './_baseContainer';
import { registerAuthToken, } from '../actions/auth';
import Login from '../components/login/Login';

// Login has to re-render when the session changes — signing in and unlocking both
// only touch the store, and it is Login that redirects on to the dashboard.
const mapStateToProps = state => ({
  authentication: state.auth?.authentication || {},
});

const mapDispatchToProps = dispatch => ({
  registerAuthToken: data => dispatch(registerAuthToken(data)),
});

export default baseContainer(mapStateToProps, mapDispatchToProps)(Login);
